import { useIsScreenDown } from '@/hooks/useIsScreenDown'
import {
	ResourceContainer,
	UiVideoTile,
	Weblinkext,
	Weblinkvideo,
} from '@/kontent/content-types'
import DownloadList, {
	DEFAULT_HIDDENS_FOR_DOWNLOAD_LIST,
} from '@/legacy-ported/components/syllabus/DownloadList'
import { DownloadListField } from '@/types/downloadList'
import { fnExist } from '@/utils'
import { Elements, IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import { useMemo } from 'react'
import { useAssetsFromAssetsElement } from '../contexts/AssetsProvider'
import { getLinkedItems } from '../contexts/KontentHomeConfigProvider'

export interface AssessmentResourceSectionProps {
	linkedItems: IContentItemsContainer
	resources: Elements.LinkedItemsElement<ResourceContainer>
	otherResources: Elements.LinkedItemsElement<
		UiVideoTile | Weblinkext | Weblinkvideo
	>
	pageType?: string
}

export const ASSESSMENT_RESOURCE_SECTION_HIDDEN_FIELDS: DownloadListField[] = [
	...DEFAULT_HIDDENS_FOR_DOWNLOAD_LIST,
	'stage',
	'resourceType',
	'year',
]

const useCombinedResourceAndOtherResources = (
	resources: Elements.LinkedItemsElement<ResourceContainer>,
	otherResources: Elements.LinkedItemsElement<
		UiVideoTile | Weblinkext | Weblinkvideo
	>,
	linkedItems: IContentItemsContainer,
) => {
	const _resources = getLinkedItems(resources, linkedItems)
	const assets = useAssetsFromAssetsElement(_resources)
	const _otherResources = getLinkedItems(otherResources, linkedItems)
	return [...assets, ...(_otherResources || [])].filter(fnExist)
}

export const AssessmentResourceSection = (
	props: AssessmentResourceSectionProps,
) => {
	const isScreenDownMd = useIsScreenDown('md')
	const { linkedItems, resources, otherResources, pageType } = props

	const files = useCombinedResourceAndOtherResources(
		resources,
		otherResources,
		linkedItems,
	)

	const downloadListHiddenFields = useMemo<DownloadListField[]>(() => {
		if (isScreenDownMd) {
			return [
				...ASSESSMENT_RESOURCE_SECTION_HIDDEN_FIELDS,
				'fileSize',
				'fileType',
			]
		}
		return ASSESSMENT_RESOURCE_SECTION_HIDDEN_FIELDS
	}, [isScreenDownMd])

	if (!files?.length) return

	return (
		<DownloadList
			files={files}
			hiddenFields={downloadListHiddenFields}
			hideCheckbox
			pageType={pageType}
		></DownloadList>
	)
}
